export default __webpack_public_path__ + "static/media/instagram-icon.c4d6f3d1.svg";